import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

export default class DisplayRowHours extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleCopyToHours = this.handleCopyToHours.bind(this);
    this.handleCopyFromHours = this.handleCopyFromHours.bind(this);
    this.validateHours = this.validateHours.bind(this);
    this.handleHoursSave = this.handleHoursSave.bind(this);
    this.handleHoursSave = this.handleHoursSave.bind(this);
    this.handleHoursChange = this.handleHoursChange.bind(this);
  }

  handleHoursChange(event) {
    const hours = this.props.hours;
    hours[event.target.name] = event.target.value;
    this.props.setHours(hours);
  }

  handleHoursSave() {
    const valid = this.validateHours();
    if (valid) {
      const requestObject = {};
      const hours = this.formHours();
      const workHours = this.formWorkHours();
      requestObject.hours = hours;
      requestObject.workHours = workHours;
      this.props.handleClose();
      this.props.submitRequest(requestObject);
    }
  }

  handleCopyFromHours(event) {
    const hours = this.props.hours;
    hours.fromTue = hours.fromMon;
    hours.fromWed = hours.fromMon;
    hours.fromThu = hours.fromMon;
    hours.fromFri = hours.fromMon;
    this.props.setHours(hours);
  }

  handleCopyToHours(event) {
    const hours = this.props.hours;
    hours.toTue = hours.toMon;
    hours.toWed = hours.toMon;
    hours.toThu = hours.toMon;
    hours.toFri = hours.toMon;
    this.props.setHours(hours);
  }

  validateHours() {
    let valid = true;
    let errorString = '';
    const hours = this.props.hours;
    if (hours.allDay === '') {
      errorString = `Choose 24 hours(Yes/No) for ${this.props.id}`;
      this.props.setErrorStringsetState(errorString);
      valid = false;
      return valid;
    }
    if (hours.allDay === '0') {
      const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      let noDays = true;
      // TODO: refactor loop to prevent "no-restricted-syntax" error
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const day in days) {
        const from = `from${days[day]}`;
        const to = `to${days[day]}`;
        if (hours[from] === '' && hours[to] === '') {
          // eslint-disable-next-line no-continue
          continue;
        } else if (hours[from] === '') {
          noDays = false;
          valid = false;
          errorString = `Both Start Hours and End hours for ${days[day]} should be present or absent`;
          break;
        } else if (hours[to] === '') {
          noDays = false;
          valid = false;
          errorString = `Both Start Hours and End hours for ${days[day]} should be present or absent`;
          break;
        } else if (hours[from] >= hours[to]) {
          noDays = false;
          valid = false;
          errorString = `Start Hours for ${days[day]} should be a time in past to End hours`;
          break;
        } else {
          noDays = false;
          valid = true;
        }
      }
      if (noDays) {
        valid = false;
        errorString = `Time should be entered for atleast one day`;
      }
    } else {
      valid = true;
    }
    this.props.setErrorString(errorString);
    return valid;
  }

  formHours() {
    // var locationString = JSON.stringify(this.state.location);
    // var locationObject = JSON.parse(locationString);
    const hoursString = JSON.stringify(this.props.hours);
    const hoursObject = JSON.parse(hoursString);
    if (hoursObject.allDay === '1') {
      return '24 Hours';
    }
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const dailyHours = this.props.hours;
    let prevFrom = 'fromMon';
    let prevTo = 'toMon';
    const outputDays = ['0'];
    let hours = '';
    let i = 0;
    let from;
    let to;
    for (i = 0; i < days.length; i++) {
      from = `from${days[i]}`;
      to = `to${days[i]}`;
      if (
        dailyHours[from].trim().length === 0 ||
        dailyHours[to].trim().length === 0
      ) {
        dailyHours[from] = '';
        dailyHours[to] = '';
      }
    }
    for (i = 1; i < days.length; i++) {
      from = `from${days[i]}`;
      to = `to${days[i]}`;
      if (
        dailyHours[from] === dailyHours[prevFrom] &&
        dailyHours[to] === dailyHours[prevTo]
      ) {
        let temp = outputDays.pop();
        temp = `${temp},${i}`;
        outputDays.push(temp);
      } else {
        outputDays.push(i.toString());
      }
      prevFrom = from;
      prevTo = to;
    }
    outputDays.forEach(function (str) {
      const start = parseInt(str.charAt(0), 10);
      const end = parseInt(str.charAt(str.length - 1), 10);
      let tempHours = '';
      if (days[start] === days[end]) {
        tempHours = `${tempHours + days[start]} `;
      } else {
        tempHours = `${tempHours + days[start]}-${days[end]} `;
      }
      if (
        dailyHours[`from${days[start]}`].trim().length === 0 ||
        dailyHours[`to${days[start]}`].trim().length === 0
      ) {
        return;
      }
      tempHours = `${tempHours + dailyHours[`from${days[start]}`]} to ${
        dailyHours[`to${days[start]}`]
      }; `;

      hours += tempHours;
    });
    return hours;
  }

  formWorkHours() {
    // let locationString = JSON.stringify(this.state.location);
    // let locationObject = JSON.parse(locationString);
    const hoursString = JSON.stringify(this.props.hours);
    const hoursObject = JSON.parse(hoursString);
    let workHours = {};
    if (hoursObject.allDay === '1') {
      workHours = {
        Mon: [['00:00', '23:59']],
        Tue: [['00:00', '23:59']],
        Wed: [['00:00', '23:59']],
        Thu: [['00:00', '23:59']],
        Fri: [['00:00', '23:59']],
        Sat: [['00:00', '23:59']],
        Sun: [['00:00', '23:59']],
      };
      return workHours;
    }
    if (this.props.hours.fromMon !== '' && this.props.hours.toMon !== '') {
      workHours.Mon = [[this.props.hours.fromMon, this.props.hours.toMon]];
    }
    if (this.props.hours.fromTue !== '' && this.props.hours.toTue !== '') {
      workHours.Tue = [[this.props.hours.fromTue, this.props.hours.toTue]];
    }
    if (this.props.hours.fromWed !== '' && this.props.hours.toWed !== '') {
      workHours.Wed = [[this.props.hours.fromWed, this.props.hours.toWed]];
    }
    if (this.props.hours.fromThu !== '' && this.props.hours.toThu !== '') {
      workHours.Thu = [[this.props.hours.fromThu, this.props.hours.toThu]];
    }
    if (this.props.hours.fromFri !== '' && this.props.hours.toFri !== '') {
      workHours.Fri = [[this.props.hours.fromFri, this.props.hours.toFri]];
    }
    if (this.props.hours.fromSat !== '' && this.props.hours.toSat !== '') {
      workHours.Sat = [[this.props.hours.fromSat, this.props.hours.toSat]];
    }
    if (this.props.hours.fromSun !== '' && this.props.hours.toSun !== '') {
      workHours.Sun = [[this.props.hours.fromSun, this.props.hours.toSun]];
    }
    return workHours;
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            <font className="mandatory">*</font>
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.displayString}
        </td>
        {this.props.edit && (
          <Modal show={this.props.edit} dialogClassName="custom-modal">
            <Modal.Header>
              <Modal.Title>Hours</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label className="col-sm-2 control-label">
                  24 Hours ?<font className="mandatory">*</font>
                </label>
                <select
                  value={this.props.value.allDay}
                  name="allDay"
                  onChange={this.handleHoursChange}
                  className="form-control"
                  required
                >
                  <option value="">Choose a value</option>
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </select>
                {this.props.value.allDay === '0' && (
                  <table id="weekHoursTable">
                    <tbody>
                      <tr>
                        <th> </th>
                        <th>Mon</th>
                        <th>Tuesday</th>
                        <th>Wednesday</th>
                        <th>Thursday</th>
                        <th>Friday</th>
                        <th>Saturday</th>
                        <th>Sunday</th>
                        <th> </th>
                      </tr>
                      <tr>
                        <td>From</td>
                        <td>
                          <input
                            name="fromMon"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromMon}
                          />
                        </td>
                        <td>
                          <input
                            name="fromTue"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromTue}
                          />
                        </td>
                        <td>
                          <input
                            name="fromWed"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromWed}
                          />
                        </td>
                        <td>
                          <input
                            name="fromThu"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromThu}
                          />
                        </td>
                        <td>
                          <input
                            name="fromFri"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromFri}
                          />
                        </td>
                        <td>
                          <input
                            name="fromSat"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromSat}
                          />
                        </td>
                        <td>
                          <input
                            name="fromSun"
                            type="time"
                            onChange={this.handleHoursChange}
                            value={this.props.value.fromSun}
                          />
                        </td>
                        <td>
                          <input
                            type="button"
                            value="Copy till friday"
                            onClick={this.handleCopyFromHours}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>To</td>
                        <td>
                          <input
                            name="toMon"
                            type="time"
                            min={this.props.value.fromMon}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toMon}
                          />
                        </td>
                        <td>
                          <input
                            name="toTue"
                            type="time"
                            min={this.props.value.fromTue}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toTue}
                          />
                        </td>
                        <td>
                          <input
                            name="toWed"
                            type="time"
                            min={this.props.value.fromWed}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toWed}
                          />
                        </td>
                        <td>
                          <input
                            name="toThu"
                            type="time"
                            min={this.props.value.fromThu}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toThu}
                          />
                        </td>
                        <td>
                          <input
                            name="toFri"
                            type="time"
                            min={this.props.value.fromFri}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toFri}
                          />
                        </td>
                        <td>
                          <input
                            name="toSat"
                            type="time"
                            min={this.props.value.fromSat}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toSat}
                          />
                        </td>
                        <td>
                          <input
                            name="toSun"
                            type="time"
                            min={this.props.value.fromSun}
                            onChange={this.handleHoursChange}
                            value={this.props.value.toSun}
                          />
                        </td>
                        <td>
                          <input
                            type="button"
                            value="Copy till friday"
                            onClick={this.handleCopyToHours}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
              <font className="mandatory">{this.props.errorString}</font>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                onClick={this.props.handleClose}
                type="button"
                className="btn modalButtons btn-primary"
              >
                Close
              </button>
              <button
                onClick={this.handleHoursSave}
                type="button"
                className="btn modalButtons btn-success"
              >
                Save
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </tr>
    );
  }
}
